<template>
    <t-section class="product-section"
       v-bind:schemaName="'product'"
       v-bind:headers="headers"
       v-bind:isCustomRow="true"
       v-bind:fields="fields">

        <template v-slot:buttons>
            <button type="button"
               :disabled="isSyning"
               class="btn btn-sm btn-outline-primary"
               v-on:click="sync">Синхронізувати</button>
        </template>
        <template v-slot:count>
            <div class="col-sm">Сума опт: {{ totalWholeSale }}</div>
        </template>
        <template v-slot:body="{ data, headers, getRowValue, router, pageCount }">
            <tbody v-for="(row, index) of data"
               v-bind:key="row.id">
                <tr> 
                    <td v-on:click.prevent="getRemains(row.id)"
                       v-if="remains.filter(x => x?.productId == row.id).length == 0">+</td>
                    <td v-on:click.prevent="removeRemains(row.id)"
                       v-else>-</td>                                          
                    <td>{{ index + pageCount }}</td>
                    <td v-for="header of headers"
                       v-bind:key="header.field + row.id"
                       v-bind:class="header.class ? header.class : ''"
                       v-bind:style="header.style ? header.style : null"
                       v-on:click.prevent="router(getRowValue(row, header.router), header.router.name)">
                        {{ getRowValue(row, header) }}
                    </td>
                </tr>
                <td :colspan="headers.length + 2"
                   v-if="remains?.filter(x => x?.productId == row.id).length > 0">
                    <table class="col">
                        <thead>
                            <tr class="col">
                                <th class="text-center">{{ $filters.localize("tableColumns.product.totalWholesale") }}: {{ remains.filter(x => x?.productId == row.id).map(x =>
                                    x.quantity)
                                    .reduce((total, amount) => total += amount * row.wholeSalePrice, 0) }}</th>
                                <th class="text-center">{{ $filters.localize("tableColumns.product.totalPairs") }}: {{ remains.filter(x => x?.productId == row.id).map(x =>
                                    x.quantity)
                                    .reduce((total, amount) => total + amount, 0) }}</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr class="rounded shadow">
                                <th class="text-center">
                                    {{ $filters.localize('main.size') }}
                                </th>
                                <th class="text-center">
                                    {{ $filters.localize('main.countTitle') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row of remains.filter(x => x?.productId == row.id)"
                               v-bind:key="row.id">
                                <td>
                                    {{ row.character?.code }}
                                </td>
                                <td>
                                    {{ row.quantity }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tbody>
        </template>
    </t-section>
</template>

<script>
import TSection from '@/components/Sections/Section.vue';
export default {
    name: "ProductSection",
    components: {
        TSection,
    },
    methods: {
        getRemains(rootId) {
            this.$store.dispatch('getFilter', { table: "productRemains", body: { id: rootId, rootColumn: "ProductId" } })
                .then((response) => {
                    this.remains = [...this.remains, ...response.data.data];
                });
        },
        removeRemains(rootId) {
            this.remains = this.remains.filter(x => x?.productId !== rootId);
        },
        calculateTotalRemains() {
            this.$store.dispatch('get', { table: "productRemains", method: "totalWholeSale" })
                .then(response => {
                    this.totalWholeSale = response.data.data;
                });
            return 0;
        },
        async sync() {
            this.isSyning = true;
            await this.$store.dispatch('post', { table: 'product', method: 'sync', body: {} });
            this.$toast.success("Синхронізація успішно запущена, можливо займе 10-15 хвилин.");
        },

        reset() {
            this.isSyning = false;
        }
    },
    mounted() {
        this.reset();
        this.calculateTotalRemains();
    },
    data() {
        return {
            headers: [
                {
                    field: "name",
                    name: this.$filters.localize('ProductPage.fields.name'),
                    sort: true,
                    router: { field: "id", name: "ProductPage" },
                    class: "product-col-name",
                },
                {
                    field: "code",
                    name: this.$filters.localize('ProductPage.fields.code'),
                    sort: true,
                    router: { field: "id", name: "ProductPage" },
                    class: "product-col-code",
                }
            ],
            remains: [],
            totalWholeSale: 0,
            isSyning: false,
            fields: [
                { field: "code", name: this.$filters.localize('ProductPage.fields.code'), type: "number" },
                { field: "isPromotion", name: this.$filters.localize('ProductPage.fields.isPromotion'), type: "lookup", lookup: [{ id: "true", name: "Так" }, { id: "false", name: "Ні" }] },
                { field: "isTailoringAvailable", name: this.$filters.localize('ProductPage.fields.isTailoringAvailable'), type: "lookup", lookup: [{ id: "true", name: "Так" }, { id: "false", name: "Ні" }] }
            ]
        }
    }
}
</script>

<style scoped>
:deep(.product-section .section-table) {
    table-layout: fixed;
    min-width: 560px;
}

:deep(.product-section .section-table .product-col-name) {
    width: auto;
    min-width: 260px;
    text-align: left;
}

:deep(.product-section .section-table .product-col-code) {
    width: 140px;
    max-width: 140px;
}

:deep(.product-section .section-table th.product-col-code),
:deep(.product-section .section-table td.product-col-code) {
    white-space: nowrap;
}
</style>
